import { Dispatch } from "./reducer";
import { getEvents } from "../../lib/eventRequests";

export const loadEvents = async (dispatch: Dispatch) => {
  dispatch({
    type: "loadingEvents",
  });

  try {
    const response = await getEvents();

    return dispatch({
      type: "setEvents",
      payload: {
        ...response,
      },
    });
  } catch (err) {
    return dispatch({
      type: "setEventsError",
      payload: err,
    });
  }
};

export const loadUpcomingEvents = async (
  dispatch: Dispatch,
  upcomingEvents
) => {
  dispatch({
    type: "loadingEvents",
  });

  try {
    return dispatch({
      type: "setEvents",
      payload: {
        data: { 
          upcoming: upcomingEvents || [] 
        },
      },
    });
  } catch (err) {
    return dispatch({
      type: "setEventsError",
      payload: err,
    });
  }
};

export const loadPastEvents = async (dispatch: Dispatch, pastEvents) => {
  dispatch({
    type: "loadingEvents",
  });

  try {
    return dispatch({
      type: "setEvents",
      payload: {
        data: {
          past: pastEvents || [],
        }
      },
    });
  } catch (err) {
    return dispatch({
      type: "setEventsError",
      payload: err,
    });
  }
};
